import clsx from 'clsx';
import { LoadingIcon } from '@/icons';

export function Spinner(props: { className?: string }) {
    return <LoadingIcon className={clsx('animate-spin size-5', props.className)} />;
}
